import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BankSelectorPage } from './bank-selector';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    BankSelectorPage,
  ],
  imports: [
    IonicPageModule.forChild(BankSelectorPage),
    ComponentsModule
  ],
})
export class BankSelectorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/bank-selector/bank-selector.module.ts